import { useTranslation } from '../../i18n';

type Status = 'free' | 'occupied' | 'unavailable' | 'claimed_for_future';

const CHIP_CLASS: Record<Status, string> = {
  free:               'chip chip-free',
  occupied:           'chip chip-occ',
  unavailable:        'chip chip-inact',
  claimed_for_future: 'chip chip-future',
};

const TRANSLATION_KEY: Record<Status, string> = {
  free:               'spot_status_free',
  occupied:           'spot_status_occupied',
  unavailable:        'spot_status_unavailable',
  claimed_for_future: 'spot_status_claimed_for_future',
};

export function StatusBadge({ status }: { status: Status }) {
  const { t } = useTranslation();

  return (
    <span className={CHIP_CLASS[status]}>
      {t(TRANSLATION_KEY[status]).toUpperCase()}
    </span>
  );
}
